export const LEGAL_CHANGES_TO_TERMS: string = `

### <!--= ++sectionIndex -->. Changes to These Terms

We reserve the right, at our sole discretion, to modify or replace these Terms of Use at any time. Such changes may be necessary due to a number of reasons, including, but not limited to:

- Changes in the legal landscape
- Shifts in supreme judicial case law
- Modifications in economic conditions or the market situation
- Technical adjustments to our services

Should a revision be material, we will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. We will notify users of such changes by any reasonable means, including by posting a revised version of these Terms of Use on our service or other notification.

Your continued use of our services following the posting of changes to these Terms of Use will mean you accept those changes. If you do not agree to the new terms, in whole or in part, please stop using the website and the services.

Unless explicitly stated otherwise, these Terms of Use, together with any other legal notices published by us on our services, shall constitute the entire agreement between you and us concerning the services, superseding any prior agreements, whether written or oral, in relation to the subject matter of these Terms of Use.
`;
